export const initialState = {
    loading: 0,
    user: {},
    album: {
        list: [],
        total: 0,
        fieldList: []
    },
    artist: {
        list: [],
        total: 0,
        listWithAlbums: [],
        totalListWithAlbums: 0,
    },
    albumType: {
        list: []
    },
    albumTrack: {
        list: []
    },
    albumImage: {
        list: []
    },
    comment: {
        total: 0,
        list: []
    }
}